import { useMemo } from 'react';

import {
  AppOffer,
  AppOfferListItem,
  LoyaltyEngineId,
  LoyaltyOffer,
  appOfferToLoyaltyOffer,
  isAppOffer,
  isAppOfferGroup,
  isAppPersonalizedOffer,
  isAppPersonalizedOfferGroup,
} from 'state/loyalty/types';

type SelectedIncentive = (LoyaltyOffer & { isUnavailable?: boolean }) | undefined;

function findAppOfferById(items: AppOfferListItem[], id: LoyaltyEngineId) {
  for (const item of items) {
    if (isAppOffer(item) && item.loyaltyEngineId === id) {
      return item;
    }

    if (isAppPersonalizedOffer(item) && item.configId === id) {
      return item;
    }

    if (isAppOfferGroup(item)) {
      const child = item.offers?.find(o => o.loyaltyEngineId === id);
      if (child) {
        return child;
      }
    }
    if (isAppPersonalizedOfferGroup(item)) {
      const child = item.offers?.find(o => o.loyaltyEngineId === id);
      if (child) {
        return child;
      }
    }
  }
}

export const useServiceIncentive = ({
  loyaltyEngineId,
  offerListItems,
  offersInCart,
}: {
  loyaltyEngineId: LoyaltyEngineId;
  offerListItems: AppOfferListItem[];
  offersInCart: AppOffer[];
}) => {
  const selectedIncentive: SelectedIncentive = useMemo(() => {
    const offerInCart = offersInCart.find(offer => offer.loyaltyEngineId === loyaltyEngineId);
    if (offerInCart) {
      return appOfferToLoyaltyOffer(offerInCart);
    }

    const offerInList = findAppOfferById(offerListItems, loyaltyEngineId);
    if (offerInList) {
      return appOfferToLoyaltyOffer(offerInList);
    }

    return undefined;
  }, [loyaltyEngineId, offerListItems, offersInCart]);

  return { selectedIncentive };
};
